import { AudioWaveform } from 'lucide-react';
import { toast } from 'sonner';

const TOAST_DURATION = 10_000;

export function showNoteGeneratingToast(clientName: string | undefined) {
    const firstName = clientName?.trim().split(/\s+/)[0];

    toast(firstName ? `Generating ${firstName}'s note` : 'Generating your note', {
        icon: <AudioWaveform className="size-5 text-secondary" />,
        duration: TOAST_DURATION,
    });
}
